import * as React from 'react'
import { PageContent } from '@components/pages'
import { PageContentHeader } from '@components/pages/page-content-header'
import { Paths } from '@logic'
import { EmptyState } from '@shared/components/empty-state'
import { BaseLinkProps } from '@components/navigation/navigation'

export const ActivityLogPage: React.FC<any> = () => {
  const parent: BaseLinkProps = { path: Paths.adminRoot }

  return (
    <PageContent>
      <PageContentHeader title="Activity Log" parent={parent} />
      <EmptyState
        title="Activity Log Contract"
        description="No command-center audit stream endpoint is mounted yet. This page remains a placeholder until an activity contract exists in equa-server."
      />
    </PageContent>
  )
}
